<template>
    <h5 class="text-white mb-2 text-sm">
        The recommended aspect ratio for the best user experience is
        <b>{{ ratio }}</b>.
    </h5>
</template>

<script>
import {fileDefinition} from "@/Pages/Media/MediaLibraryLogic";

export default {
    props: ['uploadBoxType'],
    data(){
        return {
            ratio: null,
        }
    },
    mounted(){
         this.ratio = fileDefinition.get(this.uploadBoxType) .ratio;

            // if(this.uploadBoxType == 'provider-logo')
            // {
            //    this.ratio = '1:1';
            // }
        //
        // if(this.uploadBoxType == 'provider-info-images')
        // {
        //    this.ratio = '4:3';
        // }
        //
        // if(this.uploadBoxType == 'audio-feature-preview')
        // {
        //    this.ratio = '9:16';
        // }
        //
        // if(this.uploadBoxType == 'ar-feature-preview')
        // {
        //    this.ratio = '1:1';
        // }
        //
        // if(this.uploadBoxType == 'ar-object-image')
        // {
        //    this.ratio = '1:1';
        // }
            //
            // if(this.uploadBoxType == 'tour-image')
            // {
            //    this.ratio = '1:1';
            // }
            //
            // if(this.uploadBoxType == 'tour-logo')
            // {
            //    this.ratio = '1:1';
            // }
        //
        // if(this.uploadBoxType == 'gallery-image')
        // {
        //    this.ratio = '16:9, 9:16';
        // }
        //
        // if(this.uploadBoxType == 'gallery-thumbnail')
        // {
        //    this.ratio = '16:9, 9:16';
        // }
        //
        // if(this.uploadBoxType == 'station-image')
        // {
        //    this.ratio = '4:3 or 1:1 (horizontal view), 8:3 (vertical view)';
        // }
        //
        // if(this.uploadBoxType == 'station-logo')
        // {
        //    this.ratio = '1:1';
        // }
        // if(this.uploadBoxType == 'panorama-image')
        // {
        //    this.ratio = '1:1';
        // }
    }
}
</script>
